import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import Monogram from "./Monogram";

export const AuthCard = ({ title, subtitle, children, testId }) => (
  <div className="min-h-[75vh] flex items-center justify-center px-4 py-12" data-testid={testId}>
    <div className="p-card p-7 md:p-12 max-w-lg w-full reveal">
      <div className="flex justify-center mb-6"><Monogram size="lg" /></div>
      <div className="eyebrow mb-3 text-center">Estudio del Pastor</div>
      <h1 className="hero-headline text-4xl md:text-5xl mb-4 text-center">{title}</h1>
      {subtitle && <p className="text-[#3F433C] text-lg md:text-xl mb-8 text-center leading-relaxed">{subtitle}</p>}
      {children}
    </div>
  </div>
);

export const BigField = ({ label, id, ...props }) => (
  <div className="mb-6">
    <label htmlFor={id} className="block text-lg md:text-xl font-semibold text-[#1B1C1A] mb-2">{label}</label>
    <input id={id} className="auth-input" {...props} />
  </div>
);

export const PasswordField = ({ label, id, value, onChange, testId, autoComplete = "current-password" }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="mb-6">
      <label htmlFor={id} className="block text-lg md:text-xl font-semibold text-[#1B1C1A] mb-2">{label}</label>
      <div className="relative">
        <input
          id={id}
          type={show ? "text" : "password"}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          required
          className="auth-input pr-36"
          data-testid={testId}
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          className="auth-toggle"
          aria-label={show ? "Ocultar contraseña" : "Mostrar contraseña"}
          data-testid={`${testId}-toggle`}
        >
          {show ? <EyeOff size={22} /> : <Eye size={22} />} {show ? "Ocultar" : "Mostrar"}
        </button>
      </div>
    </div>
  );
};

export const AuthError = ({ message }) =>
  message ? (
    <div role="alert" className="mb-6 rounded-2xl border-2 border-[#B42318] bg-[#FEF3F2] px-5 py-4 text-lg text-[#912018]" data-testid="auth-error">
      {message}
    </div>
  ) : null;

export const AuthNotice = ({ children, testId }) => (
  <div className="mb-6 rounded-2xl border-2 border-[#A36A00] bg-[#FFF8E6] px-5 py-4 text-lg text-[#5C3D00]" data-testid={testId}>
    {children}
  </div>
);
